import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useIframe } from "../hooks/useIframe";
import { useMediaQuery } from "react-responsive";

export function RecordSearch({ category, domain }) {
  const isMobile = useMediaQuery({ maxWidth: 820 });
  const [title, setTitle] = useState("개인참가기록");
  const [name, setName] = useState("");
  const [year, setYear] = useState("");
  const [number, setNumber] = useState("");
  const { setMoveUrl } = useIframe();

  useEffect(() => {
    setTitle(
      category === "individual"
        ? "개인 참가 기록"
        : category === "group"
        ? "단체 참가 기록"
        : category === "club"
        ? "대항전 참가 기록"
        : "개인 참가 기록"
    );
  }, []);

  const handleSearchButton = () => {
    setMoveUrl(
      `${domain}/records?mode=result&category=${category}&name=${name}&year=${year}&number=${number}`
    );
  };

  return (
    <Container ismobile={isMobile}>
      <Title>대회기록</Title>
      <SubTitle>
        {" "}
        <b>
          <i className="bi bi-arrow-right-circle-fill"></i>
        </b>
        {title} <span>※ 대회 종료 후 참가자 기록 검색이 가능합니다.</span>
      </SubTitle>
      <FormContainer ismobile={isMobile}>
        <FormWrapper ismobile={isMobile}>
          <FormKey ismobile={isMobile}>
            배번 <b>*</b>
          </FormKey>
          <div className="value">
            <input
              type="text"
              name="number"
              placeholder="ex)123"
              required
              onChange={(event) => setNumber(event.target.value)}
            />
          </div>
        </FormWrapper>
        <FormWrapper ismobile={isMobile}>
          <FormKey ismobile={isMobile}>
            성명 <b>*</b>
          </FormKey>
          <div className="value">
            <input
              type="text"
              name="name"
              placeholder="성명"
              required
              onChange={(event) => setName(event.target.value)}
            />
            <span>※ 실명으로 입력, 띄어쓰기 금지</span>
          </div>
        </FormWrapper>
        <FormWrapper ismobile={isMobile}>
          <FormKey ismobile={isMobile}>
            대회년도 <b>*</b>
          </FormKey>
          <div className="value">
            <input
              type="text"
              name="year"
              value={year}
              placeholder="0000"
              required
              onChange={(event) => setYear(event.target.value)}
            />
            <input type="button" value="검색" onClick={handleSearchButton} />
          </div>
        </FormWrapper>
      </FormContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: ${(props) => (props.ismobile ? "90%" : "82%")};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 5rem 0;
`;
const Title = styled.div`
  color: #222;
  font-family: "Jalnan", sans-serif;
  font-size: 4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -0.8px;
  & b {
    color: #ff791a;
  }
`;
const SubTitle = styled.div`
  font-size: 2rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.8px;
  margin: 6rem 0 3rem;
  & b {
    color: #ff791a;
    margin-right: 1rem;
  }
  & span {
    font-weight: 400;
    font-size: 1.4rem;
  }
`;
const FormContainer = styled.div`
  overflow: hidden;
  border-radius: 15px;
  border: 1.5px solid #d9d9d9;
  width: 100%;
  display: flex;
  flex-direction: column;
  & input[type="button"] {
    padding: 1.4rem 2rem;
    border: 1.2px solid #d9d9d9;
    background: #d9d9d9;
    color: #4f4f4f;
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.2px;
    cursor: pointer;
    margin-left: 1rem;
    margin-top: ${(props) => (props.ismobile ? "1rem" : "0")};
  }
  & > div {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1.5px solid #d9d9d9;
    box-sizing: border-box;

    &:last-child {
      border-bottom: 0;
    }
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: ${(props) => (props.ismobile ? "2rem" : "3.5rem")};
  input[type="text"],
  input[type="tel"],
  input[type="date"],
  input[type="email"],
  input[type="password"] {
    color: #555;
    font-family: "Nanum Gothic", sans-serif;
    width: ${(props) => (props.ismobile ? "100%" : "30rem")};
    border: 1.2px solid #d9d9d9;
    margin-left: ${(props) => (props.ismobile ? "1rem" : "2rem")};
    padding: ${(props) => (props.ismobile ? "1rem" : "1.4rem")};
  }
  input[type="radio"] {
    margin-left: 2rem;
  }
  &:last-child {
    border-bottom: 0;
  }
  & > .value {
    display: flex;
    flex-direction: ${(props) => (props.ismobile ? "column" : "row")};
  }
  & > div span {
    margin-left: ${(props) => (props.ismobile ? "1rem" : "2rem")};
    color: #555;
    font-size: 13px;
    line-height: 100%;
    letter-spacing: -0.2px;
    margin-top: ${(props) => (props.ismobile ? "1rem" : "0rem")};
  }
`;

const FormKey = styled.div`
  width: ${(props) => (props.ismobile ? "30%" : "20%")};
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 17px;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.2px;
  border-right: 1px solid #d9d9d9;

  & > b {
    color: #d10000;
  }
`;
